<template>
  <el-dialog
    v-loading="isLoading"
    :visible="isOpen"
    :close-on-click-modal="!isLoading"
    :close-on-press-escape="!isLoading"
    :before-close="() => handleClose(false)"
    :show-close="false"
    :title="$t('route.orderAppeal')"
    width="40%"
    top="6vh"
  >
    <template v-if="data">
      <generic-form
        ref="form"
        :attributes="{ disabled: isLoading, labelWidth: '112px' }"
        :form="data"
        :form-template="appealFormTemplate"
        :border="false"
        class="pt-3"
      />

      <span slot="footer">
        <el-button
          :disabled="isLoading"
          @click="handleClose"
        >{{ $t('button.cancel') }}</el-button>
        <el-button
          :disabled="isLoading"
          type="danger"
          @click="handleSave"
        >{{ $t('button.confirm') }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { createComponent, ref } from '@vue/composition-api'

import GenericForm from '../../../components/form/Form.vue'

import { appealFormTemplate } from '../../../const/goxip-circle/appeal'
import { OrderAppealsAPI } from '../../../api/memberships'

const AppealDetailDialog = createComponent({
  components: {
    GenericForm,
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isLoading = ref(false)

    const handleClose = (isSaveSuccess = false) => {
      emit('close', isSaveSuccess)
    }

    const updateDetail = async (orderAppeal) => {
      isLoading.value = true
      try {
        await OrderAppealsAPI.update({
          ...orderAppeal,
          handle_by: orderAppeal.is_handling ? props.userId : 0,
          is_settle: Number(orderAppeal.is_settle),
        })
        handleClose(true)
      } finally {
        isLoading.value = false
      }
    }

    const handleSave = () => {
      updateDetail(props.data)
    }

    return {
      isLoading,

      appealFormTemplate,

      handleClose,
      handleSave,
    }
  },
})

export default AppealDetailDialog
</script>
